module.exports = __webpack_public_path__ + "static/img/output_pdf.72a8fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/output_pdf.png
// module id = J3Xa
// module chunks = 0